import { Entity } from "@cayo/shared/api/types/cayo-graph";
import { IFormModel } from "@cayo/shared/components/Form/modelUtils/types";

export function getODataTypes(data: Entity, model: IFormModel) {
  const result: Record<string, string> = {};

  for (const key in model) {
    if (Object.prototype.hasOwnProperty.call(model, key)) {
      const odataKey = "@odata.type";

      if (data[`${key}${odataKey}`]) {
        result[`${key}${odataKey}`] = data[`${key}${odataKey}`];
      }
    }
  }

  return result;
}
